const rankingItems = [
  { rank: 1, title: '《长安十二时辰》', category: '古装悬疑', score: '9.2', trend: 'up', change: '+2' },
  { rank: 2, title: '《首尔告白》', category: '韩剧', score: '8.8', trend: 'up', change: '+5' },
  { rank: 3, title: '《山河故人》', category: '年代剧', score: '9.2', trend: 'same', change: '-' },
  { rank: 4, title: '《深海密码》', category: '悬疑', score: '8.9', trend: 'up', change: '+1' },
  { rank: 5, title: '《月光变奏曲》', category: '韩剧', score: '8.7', trend: 'down', change: '-2' },
  { rank: 6, title: '《职场风云录》', category: '都市职场', score: '8.5', trend: 'up', change: '+3' },
];

export default function Ranking() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 mb-3">
            热播排行榜
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            根据播放量、讨论热度和评分综合排序，看看大家都在追什么
          </p>
        </div>

        <div className="bg-background-100 rounded-2xl border border-background-200/60 overflow-hidden">
          <div className="hidden md:grid grid-cols-12 gap-4 px-6 py-3 text-xs font-medium text-foreground-400 border-b border-background-200/60 bg-background-200/40">
            <div className="col-span-1">排名</div>
            <div className="col-span-5">剧集名称</div>
            <div className="col-span-2">类型</div>
            <div className="col-span-2">评分</div>
            <div className="col-span-2">趋势</div>
          </div>

          {rankingItems.map((item) => (
            <div
              key={item.rank}
              className="grid grid-cols-12 gap-4 px-4 md:px-6 py-4 items-center border-b border-background-200/40 last:border-0 hover:bg-background-50 transition-colors"
            >
              <div className="col-span-2 md:col-span-1">
                <span className={`inline-flex items-center justify-center w-7 h-7 rounded-full text-xs font-bold ${
                  item.rank <= 3
                    ? 'bg-primary-500 text-white'
                    : 'bg-background-200 text-foreground-600'
                }`}>
                  {item.rank}
                </span>
              </div>
              <div className="col-span-6 md:col-span-5">
                <h3 className="text-sm font-heading font-semibold text-foreground-800 whitespace-nowrap">
                  {item.title}
                </h3>
              </div>
              <div className="col-span-2 md:col-span-2">
                <span className="text-xs text-foreground-500">{item.category}</span>
              </div>
              <div className="col-span-1 md:col-span-2">
                <span className="text-sm font-semibold text-accent-600">{item.score}</span>
              </div>
              <div className="col-span-1 md:col-span-2 flex items-center gap-1">
                {item.trend === 'up' && (
                  <span className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-arrow-up-line text-green-500 text-sm"></i>
                  </span>
                )}
                {item.trend === 'down' && (
                  <span className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-arrow-down-line text-red-400 text-sm"></i>
                  </span>
                )}
                {item.trend === 'same' && (
                  <span className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-subtract-line text-foreground-400 text-sm"></i>
                  </span>
                )}
                <span className={`text-xs font-medium ${
                  item.trend === 'up' ? 'text-green-500' : item.trend === 'down' ? 'text-red-400' : 'text-foreground-400'
                }`}>
                  {item.change}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}